// PaymentSuccess.js - Premium Design
import React, { useEffect, useState } from 'react';
import { useBooking } from '../hooks/useBooking';
import Layout from '../components/layout/Layout';
import { PAGES } from '../utils/constants';

const PaymentSuccess = () => {
  const { setCurrentPage } = useBooking();
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('orderId');
    const transactionId = urlParams.get('transactionId');
    const amount = urlParams.get('amount');

    setPaymentData({
      orderId, transactionId,
      amount: parseFloat(amount),
      timestamp: new Date().toISOString()
    });

    setTimeout(() => setCurrentPage(PAGES.CONFIRMATION), 3000);
  }, [setCurrentPage]);

  return (
    <Layout>
      <div className="flex justify-center items-center min-h-[60vh] px-4">
        <div className="glass-panel p-10 rounded-[2.5rem] text-center max-w-md border-green-500/20 shadow-2xl animate-in fade-in zoom-in duration-500">
          <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-green-500/20">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M5 13l4 4L19 7" /></svg>
          </div>
          
          <h1 className="text-3xl font-black text-white tracking-tight mb-4">Payment Captured</h1>
          <p className="text-gray-400 text-sm font-medium mb-8 leading-relaxed">
            Your transaction was processed successfully via WebXPay. We are now finalizing your chauffeur dispatch.
          </p>

          {paymentData && (
            <div className="bg-white/5 border border-white/5 rounded-2xl p-5 mb-8 space-y-3">
              <div className="flex justify-between text-[10px] font-black uppercase tracking-widest">
                <span className="text-gray-500">Order ID</span>
                <span className="text-white">{paymentData.orderId || 'N/A'}</span>
              </div>
              <div className="flex justify-between text-[10px] font-black uppercase tracking-widest">
                <span className="text-gray-500">Amount Paid</span>
                <span className="text-green-500">USD {paymentData.amount?.toFixed(2) || '0.00'}</span>
              </div>
            </div>
          )}

          <div className="flex items-center justify-center gap-3">
            <div className="w-4 h-4 border-2 border-white/10 border-t-green-500 rounded-full animate-spin"></div>
            <span className="text-[10px] text-gray-400 font-black uppercase tracking-widest">Redirecting to Voucher...</span>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentSuccess;